(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('incident-severity', {
            parent: 'entity',
            url: '/incident-severity',
            data: {
                authorities: [],
                pageTitle: 'IncidentSeverities'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/incident-severity/list/incident-severity.html',
                    controller: 'IncidentSeverityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                    var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_SEVERITY];
                    return Auth.loadActionsAccess(actions).$promise;
                }]
            },
            onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_INCIDENT_SEVERITY, access);
            }]
        });
    }
})();
